"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isMacDesktop(userAgent) {
    if (!userAgent)
        return false;
    const isDesktop = /Macintosh|Mac OS X/i.test(userAgent);
    const isPhone = /iPhone|iPad|iPod/i.test(userAgent);
    return isDesktop && !isPhone;
}
exports.default = isMacDesktop;
